import { useContext } from 'react';
import { AuthContext } from './AuthProvider';

export function useUserInfo() {
    const auth = useContext(AuthContext);

    return {
        name: auth.userInfo?.isLocum ? auth.locumUserName || '' : auth.userInfo?.name || '',
        email: auth.userInfo?.email || '',
        isLocum: auth.userInfo?.isLocum || false,
        setLocumUserName: auth.setLocumUserName ?? function noRefCheck() {}
    };
}
